<template>
  <div>
    <div class="fb-login-button" data-width="375" data-size="large" data-button-type="continue_with" data-layout="default" data-auto-logout-link="false" data-use-continue-as="true"></div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  mounted() {
    let vm = this;

    // eslint-disable-next-line
    FB.XFBML.parse();

    // eslint-disable-next-line
    FB.Event.subscribe('auth.login', function(response) {
      if (response.status == 'connected') {
        vm.loginAction(response.authResponse.accessToken);
      }
    });

    // eslint-disable-next-line
    FB.getLoginStatus(function(response) {
      // eslint-disable-next-line
      if (response.authResponse != null) {
          // eslint-disable-next-line
          FB.logout();
      }
    });
    // eslint-disable-next-line

  },
  ...mapGetters("auth/login", [
    "getInProgress",
    "getSuccess",
    "getErrorMessages",
  ]),
  methods: {
    loginAction(jwt) {
      this.logIn({ facebookToken: jwt, redirect: this.$route.query.redirect });
    },
    ...mapActions("auth/login", ["logIn"]),
  },
};
</script>